<template>
    <div class="container">
        <div class="topView">
            <div class="topView_top">
                <img class="topView_top_icon" src="../../assets/images/icon_order_unpaid.png"/>
                
                <span class="topView_top_span1" v-if ="details.actType ==1 &&details.tradeStatus ==0"  >待支付</span>
                <span class="topView_top_span" v-if ="details.actType ==1 &&( details.tradeStatus ==5 ||details.tradeStatus ==6)" >已提货</span>
                <span class="topView_top_span" v-if ="details.actType ==1 &&( details.tradeStatus ==3 ||details.tradeStatus ==4)" >待提货</span>
                <span class="topView_top_span" v-if ="details.actType ==1 &&details.tradeStatus ==7" >已取消</span>
            </div>
            <div class="topView_body">
                <span  class="topView_body_span" v-if ="details.actType ==1 &&( details.tradeStatus ==5 ||details.tradeStatus ==6)">期待为您再次服务~</span>
                <span  class="topView_body_span" v-if ="details.actType ==1 &&( details.tradeStatus ==3 ||details.tradeStatus ==4)">请到指定地点自提</span>
            </div>
        </div>
        <div class="addressView" v-if="details.templateType!='1'">
            <div class="addressViewBG">
                <div class="addressView_left">
                    <div class="addressView_left_div">
                        <img class="addressView_left_icon" src="../../assets/images/icon_ziti_address_icon.png"/>
                        <span class="addressView_left_span1">自提地址</span>
                    </div>
                    <span class="addressView_left_span2" >{{selfLiftingAddress}}</span>
                </div>
                <div class="addressView_line"></div>
                <div class="addressView_right" @click="copyTradeCodeAdress()" :data-clipboard-text="selfLiftingAddress">
                    <img class="addressView_right_icon" src="../../assets/images/icon_btn_duplicate_icon.png"/>
                    <span class="addressView_right_span">复制</span>
                </div>
            </div>
        </div>

        <div class="orderTop">
            <img class="list_box_left_icon" v-if="details.templateType=='1'" src='../../assets/images/img_mall_zfq.png' />
            <img class="orderTop_icon" :src="details.actImgPath" v-else />
             <div class="orderTop_right">
                 <span class="orderTop_right_span1">{{details.actName}}</span>
                 <span class="orderTop_right_span2">x{{details.exchangeNum}}</span>
                 <span class="orderTop_right_span3">{{details.changeVal}}积分</span>
             </div>

        </div>

        <div class="orderInfo">
            <div class="orderInfo_Top">
                <div class="orderInfo_Top_line"></div>
                <span class="orderInfo_Top_span">订单信息</span>
            </div>
            <div class="orderInfo_div">
                <span class="orderInfo_div_span1">下单人</span>
                <span class="orderInfo_div_span2">{{details.phone}}</span>
            </div>
            <div class="orderInfo_div">
                <span class="orderInfo_div_span1">订单编号</span>
                <span class="orderInfo_div_span2" :data-clipboard-text="details.id">{{details.id}}</span>
                <span class="orderInfo_div_span3" :data-clipboard-text="details.id" @click="copyTradeCode()"> 复制</span>
            </div>
            <div class="orderInfo_div">
                <span class="orderInfo_div_span1">兑换时间</span>
                <span class="orderInfo_div_span2">{{details.createTime}}</span>
            </div>
            <div class="orderInfo_div" v-if="mbActiveOutput.moneyValue">
                <span class="orderInfo_div_span1">商品金额</span>
                <span class="orderInfo_div_span2">￥{{mbActiveOutput.moneyValue}}</span>
            </div>
            <div class="orderInfo_div" v-if="details.changeVal">
                <span class="orderInfo_div_span1">使用积分</span>
                <span class="orderInfo_div_span2 changeValColor">{{details.changeVal}}</span>
            </div>
            <div class="orderInfo_div" v-if="details.deliveryTime">
                <span class="orderInfo_div_span1">自提时间</span>
                <span class="orderInfo_div_span2">{{details.deliveryTime}}</span>
            </div>
        </div>

        <div class="payAmountDiv" v-if="details.payAmount">
                <span class="payAmountDiv_span1">实付金额</span>
                <span class="payAmountDiv_span2">￥{{details.payAmount}}</span>
            
        </div>    

        

        <div v-if="details.verifier"  class="verifierInfo">
            <div class="verifierInfo_div">
                <span class="verifierInfo_div_span1">核销人: </span>
                <span class="verifierInfo_div_span2">{{details.verifier}}</span>
            </div>
            <div class="verifierInfo_div">
                <span class="verifierInfo_div_span1">核销时间: </span>
                <span class="verifierInfo_div_span2">{{details.verifiyTime }}</span>
            </div>
        
        
        </div>

        <div class="QRCodeDiv" v-if ="QRCode && details.actType ==1 &&( details.tradeStatus ==3 ||details.tradeStatus ==4)">
            <img class="QRCodeImg" :src="QRCode" />

        </div>

        <div class="footDiv" v-if="details.actType ==1 &&details.tradeStatus ==0">
            <div class="footButtton1" @click="cancelTradeAction()">取消订单</div>
            <div class="footButtton2" @click="goPayCenter(orderNo)">立即支付</div>
        </div>
        
    </div>
</template>

<script>
import { mapState } from 'vuex'
import {getMbActiveTradeById ,transformToBase64 ,cancelTrade } from "../../utils/api";
import Clipboard from 'clipboard';
import util from '../../utils/util';
import ping from '../../utils/pingpay.js'
export default {
  name: "PointOrderDetails",
  computed: {
    ...mapState({
      common: state => state.common,
    })
  },
  data() {
    return {
     canPay:true,
      orderNo:'',
      typeList:[1,2,3,4,5,6,7,8,9,10],
      valveList:[],
      time:'',
      mbAddress:"",
      selfLiftingAddress:'',
      details:'',
      mbActiveOutput:'',
      tradeId:'',
      QRCode:'',
    }
  },
  created () {
      let query = this.$route.query;
      this.tradeId=query.id;
      this.getMbActiveTradeById ();

  },

  methods: {
      copyTradeCode () {
          console.log("in copyTradeCode");
        var clipboard = new Clipboard('.orderInfo_div_span3')
        clipboard.on('success', () => {
            util.showToast('复制成功')
            // 释放内存
                clipboard.destroy()
            })
      },
      copyTradeCodeAdress () {
        var clipboard = new Clipboard('.addressView_right')
        clipboard.on('success', () => {
            util.showToast('复制成功')
            // 释放内存
                clipboard.destroy()
            })
       },

       getMbActiveTradeById () {
            let params = {
                tradeId:  this.tradeId,
                //'6790578959831531619',
                memberCode: this.common.userInfo.memberCode
            }
            getMbActiveTradeById(params, {openId: this.common.openId, userId: this.common.userId, cityId: this.common.marketInfo.cityId}).then(res => {
                console.log(res)
                if (res.res.code === 10000) {
                    this.details = res.body.mbActiveTrade
                    this.mbActiveOutput =res.body.mbActiveOutput
                    this.orderNo =res.body.orderNo
                    this.selfLiftingAddress = res.body.mbActiveTrade.selfLiftingAddress
                    if (this.details.courierType === '2') {
                        this.mbAddress = res.body.mbAddress
                        if (this.details.sendTime) {
                            let timeString = new Date(this.details.sendTime.replace(/-/g, '/')).valueOf() + 15 * 1000 * 60 * 60 * 24 - (new Date()).valueOf()
                            this.time = parseInt(timeString / 1000 / 60 / 60 / 24) + '天' + parseInt(timeString / 1000 / 60 / 60 % 24, 10) + '时'
                        }
                    }
                    console.log(JSON.stringify(this.details))

                    var QRCodeParams ={
                        mbActiveTradeById:true,
                        tradeId:  this.tradeId,
                        memberCode: this.common.userInfo.memberCode,
                    }
                    this.getQRCode(JSON.stringify(QRCodeParams))
                }
            })
        },

        getQRCode(qrcode) {
            let content = {
                qrcode: qrcode
            }
            transformToBase64(content).then(res => {
                if (res.res.code === 10000) {
                    console.log("res二维码")
                    console.log(res)
                    this.QRCode = res.body.encodeBase64
                }
           });
        },

             // 立即支付
        goPayCenter(orderNo) {
            if (!this.canPay) { return; }
            this.canPay = false;
            let params = {
                orderNo:orderNo,
                repairNo: '', // "报修单号",
                bussinessType: "10",//积分兑换 10
                // feeCode: this.orderInfo.actId,
                // payType: '5', // "支付类型 0微信，1支付宝, 4万生活, 5,ping++"
                channel: 'wx_pub' // 渠道名
            };
            ping(
                params,
                '',
                res => {
                    this.canPay = true;
                    this.getMbActiveTradeById();
                },
                () => {
                    this.canPay = true;
                    this.getMbActiveTradeById();
                },
                () => {
                    this.canPay = true;
                    this.getMbActiveTradeById();
                }
            );
            setTimeout(() => { this.canPay = true; }, 3000)
        },
        // 取消订单
        cancelTradeAction(){
            let params = {
                tradeId:  this.tradeId,
               
            }
            cancelTrade( params).then(res => {
                if (res.res.code === 10000) {
                   
                    util.showToast(res.res.msg)
                    this.getMbActiveTradeById();
                    
                }else{
                     util.showToast(res.res.msg)
                     this.getMbActiveTradeById(); //过期也要刷新
                }
            });

        }
  },
  filters: {
    time(val) {
      return util.formatTime(new Date(val), 9);
    }
  },
}
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container{
    // width:100%;
    position: relative;
    background:#F3F4F6;
    .flex(column);

}
.topView{
    width:100%;
    height:150px;
    background:linear-gradient(270deg,rgba(255,176,0,1) 0%,rgba(255,114,0,1) 100%);
     display: flex;
    flex-direction: column;
    .topView_top{
        margin-left: 28px;
        margin-top: 28px;
        flex-direction: row;
         display: flex;
        .topView_top_icon{
            width: 36px;
            height: 36px;
        }
        .topView_top_span{
            margin-left: 14px;
            height:44px;
            font-size:32px;
            font-weight:500;
            color:rgba(255,255,255,1);
            line-height:44px;
        }

        .topView_top_span1{
            padding-left: 14px;
            padding-right: 14px;
            border-radius:8px;
            margin-left: 14px;
            height:48px;
            font-size:32px;
            font-weight:500;
            // background:rgba(252,63,86,0.1);
            font-weight:400;
            background:rgba(252,63,86,1);
            color:rgba(255,255,255,1);
            line-height:48px;
        }

    }
    .topView_body{
        display: flex;
        .topView_body_span{
            margin-left: 28px;
            margin-top: 14px;
            height:36px;
            background:rgba(0,0,0,0.1);
            border-radius:8px;
            padding-left: 14px;
            padding-right: 14px;
            font-size:24px;
            font-weight:400;
            color:rgba(255,255,255,1);
            line-height:36px;
        }
    }

}
.addressView{
    width: 100%;
    height:252px;
    background:rgba(255,255,255,1);
    .addressViewBG{
        margin-top: 28px;
        width: 92.54%;
        margin-left: 28px;
        height:196px;
        background:rgba(248,248,248,1);
        border-radius:8px;
        display: flex;
        flex-direction: row;
        .addressView_left{
            margin-left: 20px;
            margin-top: 30px;
            width: 516px;
            // background-color: blue;
            display: flex;
            flex-direction: column;
            .addressView_left_div{
                display: flex;
                flex-direction: row;
                .addressView_left_icon{
                    margin-top: 5px;
                    width: 24px;
                    height: 30px;
                }
                .addressView_left_span1{
                    height:40px;
                    font-size:28px;
                    margin-left: 4px;
                    font-weight:400;
                    color:rgba(102,102,102,1);
                    line-height:40px;
                }
            }
            .addressView_left_span2{
                display: flex;
                margin-top: 14px;
                margin-left: 48px;
                width:468px;
                height:80px;
                font-size:28px;
                font-weight:400;
                color:rgba(51,51,51,1);
                line-height:40px;
            }
        }
        .addressView_line{
            margin-left: 28px;
            margin-right: 28px;
            margin-top: 58px;
            width:2px;
            height:80px;
            background:rgba(234,234,234,1);
        }
        .addressView_right{
            margin-left: 14px;
            display: flex;
            flex-direction: column;
            .addressView_right_icon{
                margin-top: 60px;
                width: 44px;
                height: 44px;
                // background-color: blue;
            }
            .addressView_right_span{
                margin-top: 4px;
                height:32px;
                font-size:22px;
                font-weight:400;
                color:rgba(102,102,102,1);
                line-height:32px;
            }
        }
    }
}

.orderTop{
    margin-top: 14px;
    margin-bottom: 14px;
    width: 100%;
    height:236px;
    background:rgba(255,255,255,1);
    display: flex;
    flex-direction: row;
    .orderTop_icon{
        margin-top: 28px;
        margin-left: 28px;
        // background-color: blue;
        width:240px;
        height:180px;
    }
    .orderTop_right{
         margin-top: 28px;
         margin-left: 20px;
         display: flex;
         flex-direction: column;
         .orderTop_right_span1{
            display: flex;
            width:434px;
            height:64px;
            font-size:28px;
            font-weight:500;
            color:rgba(51,51,51,1);
            line-height:32px;
         }
         .orderTop_right_span2{
             margin-top: 20px;
             height:36px;
            font-size:26px;
            font-weight:400;
            color:rgba(153,153,153,1);
            line-height:36px;

         }
         .orderTop_right_span3{
             margin-top: 20px;
             height:40px;
             font-size:28px;
             font-weight:500;
             color:rgba(255,126,30,1);
             line-height:40px;
         }

    }
}

.orderInfo{
    width:100% ;
    // height:336px;
    padding-bottom: 18px;
    background:rgba(255,255,255,1);
    flex-direction: column;
    display: flex;
    .orderInfo_Top{
        margin-top: 28px;
        margin-left: 28px;
        margin-bottom: 8px;
        flex-direction: row;
        display: flex;
        align-items: center;
        .orderInfo_Top_line{
            width:6px;
            height:24px;
            background:rgba(255,126,30,1);

        }
        .orderInfo_Top_span{
            margin-left: 14px;
            height:44px;
            font-size:32px;
            font-weight:500;
            color:rgba(51,51,51,1);
            line-height:44px;

        }

    }

    .orderInfo_div{
         margin-top: 20px;
         margin-left: 28px;
         flex-direction: row;
         display: flex;
         align-items: center;
         .orderInfo_div_span1{
            height:40px;
            font-size:28px;
            font-weight:400;
            color:rgba(102,102,102,1);
            line-height:40px;
         }
         .orderInfo_div_span2{
            margin-left: 40px;
            height:40px;
            font-size:28px;
            font-weight:400;
            color:rgba(51,51,51,1);
            line-height:40px;

         }
         .changeValColor{
            color:rgba(255,126,30,1);
         }
         
         .orderInfo_div_span3{
            margin-left: 14px;
            width:96px;
            height:40px;
            border-radius:8px;
            border:1px solid rgba(218,218,218,1);
            font-size:24px;
            font-weight:400;
            color:rgba(51,51,51,1);
            line-height:40px;
            text-align: center;

         }

    }   

}
.payAmountDiv{
    width:100% ;
    height: 80px;
    background:rgba(255,255,255,1);
    margin-top: 14px;
    flex-direction: row;
     display: flex;
   justify-content: space-between;
   align-items: center;
   .payAmountDiv_span1{
            margin-left: 28px;
            height:40px;
            font-size:28px;
            font-weight:400;
            color:rgba(102,102,102,1);
            line-height:40px;
    }
    .payAmountDiv_span2{
            margin-right: 40px;
            height:40px;
            font-size:32px;
            font-weight:400;
            color:rgba(255,126,30,1);
            line-height:40px;
    }

}

.verifierInfo{
    width:100% ;
    margin-top: 14px;
    padding-bottom: 14px;
    background:rgba(255,255,255,1);
    flex-direction: column;
    display: flex;
    .verifierInfo_div{
         margin-top: 20px;
         margin-left: 28px;
         flex-direction: row;
         display: flex;
         align-items: center;
         .verifierInfo_div_span1{
            height:40px;
            font-size:28px;
            font-weight:400;
            color:rgba(102,102,102,1);
            line-height:40px;
         }
         .verifierInfo_div_span2{
            margin-left: 40px;
            height:40px;
            font-size:28px;
            font-weight:400;
            color:rgba(51,51,51,1);
            line-height:40px;

         }

    }   


}
.QRCodeDiv{
    margin-top: 14px;
    margin-bottom: 14px;
    width:100% ;
    background:rgba(255,255,255,1);
    flex-direction: row;
    display: flex;
    justify-content: center;
    .QRCodeImg{
        margin-top: 20px;
        width: 300px;
        height: 300px;
        display: flex;
        margin-bottom: 20px;

    }

}

.footDiv{
    width: 100%;
    height: 100px;
    display: flex;
    background-color: #ffffff;
    position: fixed;
    bottom: 0px;
    left: 0px;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;

    .footButtton1{
        padding-left: 30px;
        padding-right: 30px;
        height: 60px;
        display: flex;
        background:#e6e6e6;
        border-radius:8px;
        text-align: center;
        font-size:30px;
        font-weight:400;
        color:rgba(0,0,0,0.8);
        line-height:60px;
        margin-right: 28px;
    }

    .footButtton2{
        padding-left: 30px;
        padding-right: 30px;
        height: 60px;
        display: flex;
        background:linear-gradient(90deg,rgba(255,181,64,1) 0%,rgba(255,126,30,1) 100%);
        border-radius:8px;
        text-align: center;
        font-size:30px;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:60px;
        margin-right: 28px;
    }
    
}

</style>